import { useParams } from 'react-router'
import useAPI from '../../hooks/useAPI'
import { TermsModalWrap } from 'src/styles/styledcomponent/component/common'
import { TermsDetail } from 'src/types/type'
import { useEffect, useState } from 'react'

const TermsModal = (): JSX.Element => {
  const params = useParams()
  const telecom = parseInt(params.telecom as string)
  const termsOrderIdx = parseInt(params.termsOrderIdx as string)
  const [terms, setTerms] = useState<TermsDetail>({ TermsTitle: '', TermsContents: '' })

  const api = useAPI('requestTermsDetail')
  const { data: termsDetail, isSuccess } = api.useSetQuery({
    Telecom: telecom,
    Idx: termsOrderIdx,
  })

  useEffect(() => {
    if (!!termsDetail?.Body) {
      const { TermsTitle, TermsContents } = termsDetail.Body
      setTerms({ TermsTitle: TermsTitle || '', TermsContents: TermsContents || '' })
    }
  }, [termsDetail, isSuccess])

  return (
    <TermsModalWrap active={isSuccess}>
      {
        terms && <>
          <h2>{terms.TermsTitle}</h2>
          <pre dangerouslySetInnerHTML={{ __html: terms.TermsContents || '' }} />
        </>
      }
    </TermsModalWrap>
  )
}
export default TermsModal
